const mEditionBillingContentsTreeNodes = {
  mEditionBillingContentsTreeNodes: {
    actions: 'acciones',
    subcontents: 'subcontenidos',
    messages: {
      daysAfter: 'Días despúes',
      inmediate: 'Inmediato',
      notActivated: 'No Activado'
    }
  }
}

export default mEditionBillingContentsTreeNodes
